import { TabElement } from "../components/visuals/TabOptions/TabOptions";
import { FlagKey } from "./workflowModels";

export enum CompanyTabTitle {
  CompanyDescription = "Company Description",
  CompanyData = "Company Data",
  NetZeroAssessment = "Net Zero Assessment",
  EnvironmentalProfile = "Environmental Profile",
}

export interface CompanyTabElement extends TabElement {
  title: CompanyTabTitle;
  icon: string;
  activeIcon: string;
  isHovered: boolean;
  isActive: boolean;
  isLocked: boolean;
}

export type CompanySummary = {
  metric_id: string;
  compass_cid: string;
  name: string;
  flag_status: FlagKey;
  description?: string | number;
  description_fmp?: string;
  image: string;
  implicit_temperature: string;
  revenue: number;
  sector: string;
  country: string;
  employee_count?: number;
  ceo?: string;
  symbol?: string;
  price?: number;
  key_metrics?: FmpCompanyKeyMetrics;
  shares_outstanding?: number;
};

type FmpCompanyKeyMetrics = {
  market_cap: number;
  ev: number;
  p_e: number;
  roe: number;
  d_e: number;
};

export type CompanySummaryRequest = {
  compass_cid: string;
  company_name: string;
};

export enum Provider {
  SBTI = "SBTI",
  TPI = "TPI",
  CA100 = "CA100",
  NZIF = "NZIF",
  NA100 = "NA100",
}

export enum Ca100Package {
  DISCLOSURE = "CA100_disclosure",
  LOBBYING = "CA100_lobbying",
}

export enum Na100Package {
  NA100 = "NA100",
}

export enum TargetStatus {
  COMMITTED = "Committed",
  TARGETS_SET = "Targets set",
  COMMITMENT_REMOVED = "Commitment removed",
  NOT_AVAILABLE = "N/A",
}

export type PublicMetric = {
  compass_cid: string;
  name: string;
  metric_id: string;
  Data_Provider: Provider;
  Data_Package: string;
  Is_Numeric: boolean;
  Compass_Metric_Display_Name: string;
  value_text: string;
  value_numeric: number | "-";
  Compass_Metric_Description: string;
};

export type Coverage = {
  isCovered: boolean;
  title: string;
};

export enum CA100IndicatorValue {
  Y = "Y",
  Partial = "Partial",
  N = "N",
  "-" = "-",
  NotApplicable = "Not applicable",
}
